type Listener<T> = (val: T) => void;
type Unsubscriber = () => void;

export class Observable<T> {
    private _listeners: Listener<T>[] = [];

    constructor(private _val: T) {}

    get(): T {
        return this._val;
    }

    set(val: T) {
        //console.log("Observable.set this._listeners.length=", this._listeners.length);
        if (this._val !== val) {
            this._val = val;
            this._listeners.forEach(l => l(val));
        }
    }

    subscribe(listener: Listener<T>): Unsubscriber {
        //console.log("Observable.subscribe this._listeners.length=", this._listeners.length);
        this._listeners.push(listener);
        return () => {
            //console.log("Observable.unsubscribe this._listeners.length=", this._listeners.length);
            this._listeners = this._listeners.filter(l => l !== listener);
        };
    }
}